/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { ServerError, useMutation } from '@apollo/client'

import { Step1Sub0 } from './Step1Sub0'
import { Step1Sub1 } from './Step1Sub1'
import { Step1Sub2 } from './Step1Sub2'
import { Step1Sub3 } from './Step1Sub3'
import { Step1Sub4 } from './Step1Sub4'
import Alert from '../../../../_metronic/partials/alert'
import mutations from './../../../../setup/graphql/mutations'
import { fetchStop, fetchStartWithForward } from '../../../../redux/actions/common'
import {
  setLoanApplication,
  setLoanSubStep,
  setLoanEligibility,
  setLoanStep,
} from '../redux/actions'
import { AlexiApplicationTypes } from '../../../../utils/constants/AlexiApplicationType.enum'

const Step1: FC = ({
  // prevStep,
  // nextStep,
  updateApplication,
  getApplication,
}: any) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [alertMsg, setAlertMsg] = useState<string>('')
  const [alertType, setAlertType] = useState<any>('primary')
  const [mobileNo, setMobileNo] = useState<any>('')
  // const [subStep, setSubStep] = useState(1);

  const loanSubStep = useSelector((state: any) => state.loan.loanSubStep)
  const loanApplication = useSelector((state: any) => state.loan.loanApplication)
  const status = useSelector((state: any) => state.loan.loanApplicationStatus)
  const [showOtp, setShowOtp] = useState(false)

  const [createApplication, onSuccessCreateApplicaton] = useMutation(mutations.CREATE_APPLICATION)
  const [sendOTP, onSuccessSendOTP] = useMutation(mutations.SEND_OTP)
  const [validateOTP, onSucccessValidateOTP] = useMutation(mutations.VALIDATE_OTP)
  const [createLoanElgibility, onSuccessCreateLoanElgibility] = useMutation(
    mutations.CREATE_LOAN_ELIGIBILITY
  )
  const [updateLoanElgibility, onSuccessUpdateLoanElgibility] = useMutation(
    mutations.UPDATE_LOAN_ELIGIBILITY
  )

  /* useEffect(() => {
    if(status > 0) {
      const loanSubStep = status === 1 ? 1 : 0;
      dispatch(setLoanSubStep(loanSubStep));
    } else {
      history.replace('/application/type')
    }

  }, [status]) */

  /* useEffect(() => {
    let subStep = 1;
    if (status === 2) subStep = 0
    if(loanApplication) {
      const currentStep = loanApplication.applicationCompleteStep;
      if(Math.floor(currentStep) === 1 ){
        subStep = Number(currentStep.toString().split('.')[1])+1;
      }
      setSubStep(subStep)
    }

  }, [loanApplication]) */

  useEffect(() => {
    if (loanApplication !== null) {
      setMobileNo(loanApplication.mobileNumber)
    }
  }, [loanApplication])

  useEffect(() => {
    if (onSuccessCreateApplicaton.called && !onSuccessCreateApplicaton.loading) {
      dispatch(fetchStop())
      if (onSuccessCreateApplicaton.data) {
        const { createApplication } = onSuccessCreateApplicaton.data
        const mobileNo = createApplication.mobileNumber
        dispatch(setLoanApplication(createApplication))

        /**
         * Resetting Mail Sent Flag on New Application Creation
         */
        localStorage.removeItem('errorLogged')
        // dispatch(fetchStop());
        setMobileNo(mobileNo)
        sendOTP({
          variables: {
            mobileNo,
            isApplicantOrShareholder: true,
            isCoApplicantKYB: false,
          },
        })
        // localStorage.setItem('loanApplicationId', createApplication.id);
        // history.push(`/application/${createApplication.id}`)
        onSuccessCreateApplicaton.reset()
      } else {
      }

      if (onSuccessCreateApplicaton.error) {
        const { networkError } = onSuccessCreateApplicaton.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        const error = `${onSuccessCreateApplicaton.error.message},Please try refreshing page agian or if issue persists please contact support (support@credilinq.ai)`
        setShowAlert(true)
        setAlertMsg(errorList || error)
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [
    onSuccessCreateApplicaton.loading,
    onSuccessCreateApplicaton.data,
    onSuccessCreateApplicaton.error,
    onSuccessCreateApplicaton.called,
  ])

  useEffect(() => {
    if (onSuccessSendOTP.called && !onSuccessSendOTP.loading) {
      dispatch(fetchStop())
      if (onSuccessSendOTP.data) {
        if (onSuccessSendOTP.data.generateOtp.success) {
          dispatch(fetchStop())
          dispatch(setLoanSubStep(2))
          setShowOtp(true)
          localStorage.removeItem('singpass')
          localStorage.setItem('loanApplicationId', onSuccessSendOTP.data.generateOtp.id)
          localStorage.setItem('loanType', onSuccessSendOTP.data.generateOtp.type)
          history.push(`/application/${onSuccessSendOTP.data.generateOtp.id}`)
          //  setting dummy data for dev , stage and sandbox env
          if (loanApplication && loanApplication?.companyUEN) {
            if (
              ['stage', 'sandbox', 'dev', 'local'].includes(localStorage.getItem('env') as string)
            ) {
              ;(async () => {
                const response = await import(
                  `../../../../utils/custom/${loanApplication.companyUEN}/step1Sub3.json`
                )
                const eligibilityData: any = response.default
                if (eligibilityData) {
                  // Dispatch the action to update the loan eligibility in the Redux store
                  dispatch(setLoanEligibility(eligibilityData))
                }
              })()
            }
            localStorage.setItem('companyUEN', loanApplication.companyUEN)
          }
          onSuccessSendOTP.reset()
        } else {
          setShowAlert(true)
          // setAlertMsg('Error generating OTP. ');
          setAlertMsg(onSuccessSendOTP.data.generateOtp.message)
          setAlertType('primary')
          dispatch(fetchStop())
        }
      } else {
        setShowAlert(true)
        // setAlertMsg('Unfortunately, we could not find an active application with this number');
        setAlertMsg(onSuccessSendOTP.data.generateOtp.message)
        setAlertType('primary')
        dispatch(fetchStop())
      }

      if (onSuccessSendOTP.error) {
        const { networkError, graphQLErrors, message } = onSuccessSendOTP.error
        let errorList = 'ERROR: '

        // Handle network errors
        if (networkError && (networkError as ServerError)) {
          try {
            errorList += (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
          } catch (e) {
            // If network error structure is different
            errorList += networkError.message || 'Network error occurred'
          }
        }
        // Handle GraphQL errors
        else if (graphQLErrors && graphQLErrors.length > 0) {
          errorList += graphQLErrors.map((error: any) => error.message).join(', ')
        }
        // Handle any other error types with fallback to general message
        else if (message) {
          errorList += message
        } else {
          errorList += 'An unknown error occurred Please try refreshing page agian'
        }
        const error = `${onSuccessSendOTP.error.message},Please try refreshing page agian or if issue persists please contact support (support@credilinq.ai)`
        setShowAlert(true)
        setAlertMsg(errorList || error)
        setAlertType('primary')
      }
    }
  }, [
    onSuccessSendOTP.loading,
    onSuccessSendOTP.data,
    onSuccessSendOTP.error,
    onSuccessSendOTP.called,
  ])

  useEffect(() => {
    if (onSucccessValidateOTP.called && !onSucccessValidateOTP.loading) {
      dispatch(fetchStop())
      if (onSucccessValidateOTP.data) {
        if (onSucccessValidateOTP.data.validateOtp.success) {
          if (loanApplication !== null) {
            if (loanApplication.applicationCompleteStep < 5) {
              const currentStep = loanApplication.applicationCompleteStep || 1
              const currentSubStep =
                currentStep >= 2 ? 0 : Number(currentStep.toString().split('.')[1])

              let step, subStep
              if (status === 1) {
                step = currentStep < 1.4 ? Math.floor(currentStep) : Math.floor(currentStep) + 1
                subStep = currentStep < 1.4 ? (currentSubStep === 1 ? 3 : currentSubStep + 1) : 0
              } else {
                step =
                  currentStep < 1.4
                    ? Math.floor(currentStep)
                    : currentStep === 2
                    ? 2
                    : Math.floor(currentStep) + 1
                subStep = currentStep < 1.4 ? (currentSubStep === 1 ? 3 : currentSubStep + 1) : 0
              }

              if (
                step === 1 &&
                subStep === 4 &&
                loanApplication.applicationType === AlexiApplicationTypes.RECURRING_APPLICATION
              ) {
                step = 2
                subStep = 0
              }

              dispatch(setLoanStep(step))
              dispatch(setLoanSubStep(subStep))
              history.push(
                `/application/${loanApplication.id}?step=${step}${subStep > 0 ? `.${subStep}` : ''}`
              )

              /* updateApplication({
                variables: {
                  data: { applicationCompleteStep: 1.2 },
                  where: { id: loanApplication.id }
                }
              }) */
            } else {
              dispatch(setLoanStep(0))
              dispatch(setLoanSubStep(1))
              history.push(`/application/${loanApplication.id}`)
            }
          } else {
            getApplication({
              variables: {
                appId: localStorage.getItem('loanApplicationId'),
              },
            })
          }
          // dispatch(setLoanSubStep(3));
          setShowOtp(false)
          onSucccessValidateOTP.reset()
        } else {
          const message = onSucccessValidateOTP.data.validateOtp.message
          setShowAlert(true)
          setAlertMsg(message)
          setAlertType('primary')
        }
      } else {
        setShowAlert(true)
        setAlertMsg('Unable to validate the OTP provided at the moment, please try again later!')
        setAlertType('primary')
        dispatch(fetchStop())
      }

      if (onSucccessValidateOTP.error) {
        const { networkError } = onSucccessValidateOTP.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        const error = `${onSucccessValidateOTP.error.message},Please try refreshing page agian or if issue persists please contact support (support@credilinq.ai)`
        setShowAlert(true)
        setAlertMsg(errorList || error)
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [
    onSucccessValidateOTP.loading,
    onSucccessValidateOTP.data,
    onSucccessValidateOTP.error,
    onSucccessValidateOTP.called,
  ])

  useEffect(() => {
    if (onSuccessCreateLoanElgibility.called && !onSuccessCreateLoanElgibility.loading) {
      dispatch(fetchStop())
      if (onSuccessCreateLoanElgibility.data) {
        if (onSuccessCreateLoanElgibility.data) {
          const { createLoanEligibility } = onSuccessCreateLoanElgibility.data

          dispatch(setLoanEligibility(createLoanEligibility))

          const presentValue = calculatePV(createLoanEligibility)
          updateApplication({
            variables: {
              data: {
                ...(loanApplication.applicationCompleteStep < 1.3 && {
                  applicationCompleteStep: 1.3,
                }),
                debtRatio: presentValue,
              },
              where: { id: loanApplication.id },
            },
          })
          dispatch(setLoanSubStep(4))
          // dispatch(fetchStop());
          history.push(
            `/application/${loanApplication.id}?${
              loanApplication.applicationType.toLowerCase() ===
              AlexiApplicationTypes.RECURRING_APPLICATION
                ? 'step=2'
                : 'step=1.4'
            }`
          )
          onSuccessCreateLoanElgibility.reset()
        }
      } else {
      }

      if (onSuccessCreateLoanElgibility.error) {
        const { networkError } = onSuccessCreateLoanElgibility.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        const error = `${onSuccessCreateLoanElgibility.error.message},Please try refreshing page agian or if issue persists please contact support (support@credilinq.ai)`
        setShowAlert(true)
        setAlertMsg(errorList || error)
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [
    onSuccessCreateLoanElgibility.loading,
    onSuccessCreateLoanElgibility.data,
    onSuccessCreateLoanElgibility.error,
    onSuccessCreateLoanElgibility.called,
  ])

  useEffect(() => {
    if (onSuccessUpdateLoanElgibility.called && !onSuccessUpdateLoanElgibility.loading) {
      dispatch(fetchStop())
      if (onSuccessUpdateLoanElgibility.data) {
        if (onSuccessUpdateLoanElgibility.data) {
          const { updateLoanEligibility } = onSuccessUpdateLoanElgibility.data

          dispatch(setLoanEligibility(updateLoanEligibility))

          const presentValue = calculatePV(updateLoanEligibility)

          updateApplication({
            variables: {
              data: {
                ...(loanApplication.applicationCompleteStep < 1.3 && {
                  applicationCompleteStep: 1.3,
                }),
                debtRatio: presentValue,
              },
              where: { id: loanApplication.id },
            },
          })

          dispatch(setLoanSubStep(4))
          // dispatch(fetchStop());
          history.push(
            `/application/${loanApplication.id}?${
              loanApplication.applicationType.toLowerCase() ===
              AlexiApplicationTypes.RECURRING_APPLICATION
                ? 'step=2'
                : 'step=1.4'
            }`
          )
          onSuccessUpdateLoanElgibility.reset()
        }
      } else {
      }

      if (onSuccessUpdateLoanElgibility.error) {
        const { networkError } = onSuccessUpdateLoanElgibility.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        const error = `${onSuccessUpdateLoanElgibility.error.message},Please try refreshing page agian or if issue persists please contact support (support@credilinq.ai)`
        setShowAlert(true)
        setAlertMsg(errorList || error)
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [
    onSuccessUpdateLoanElgibility.loading,
    onSuccessUpdateLoanElgibility.data,
    onSuccessUpdateLoanElgibility.error,
    onSuccessUpdateLoanElgibility.called,
  ])

  const calculatePV = (loanEligibility: any) => {
    const {
      // industryType,
      profit,
      totalMonthlyInstallmentsToBanks,
      totalMonthlyInstallmentsToNonBanks,
      totalRevolvingCreditOutstandingToBanks,
      totalRevolvingCreditOutstandingToNonBanks,
    } = loanEligibility

    // const existingDebt =
    //   totalMonthlyInstallmentsToBanks +
    //   totalMonthlyInstallmentsToNonBanks +
    //   totalRevolvingCreditOutstandingToBanks * 0.05 +
    //   totalRevolvingCreditOutstandingToNonBanks * 0.05
    // const netOperatingIncome = profit / 12
    // const totalDebts = existingDebt + loanApplication.emi
    // const debtRatio = (totalDebts / netOperatingIncome) * 100

    // return debtRatio

    const monthlyRevolvingBanks = Number((totalRevolvingCreditOutstandingToBanks / 12).toFixed(6))
    const monthlyRevolvingNonBanks = Number(
      (totalRevolvingCreditOutstandingToNonBanks / 12).toFixed(6)
    )

    // Calculate total loans with 2 decimal precision
    const totalLoans = Number(
      (
        totalMonthlyInstallmentsToBanks +
        totalMonthlyInstallmentsToNonBanks +
        monthlyRevolvingBanks +
        monthlyRevolvingNonBanks
      ).toFixed(2)
    )
    // Keep monthly net operating income at 6 decimal precision
    const monthlyNetOperatingIncome = Number((profit / 12).toFixed(6))

    // Calculate 85% of profit with 2 decimal precision
    const profit85X = Number((0.85 * monthlyNetOperatingIncome).toFixed(2))

    // Final EMI calculation with 2 decimal precision
    const emiAsPerDeclaredFinancials = Number((profit85X - totalLoans).toFixed(2))

    const annualRate = 0.2
    const monthlyRate = annualRate / 12 // 20% annual interest, monthly
    const periods = 6 // 6 months
    const result = calculatePresentValue(monthlyRate, periods, emiAsPerDeclaredFinancials)
    return result
  }

  function calculatePresentValue(monthlyRate: number, tenure: number, EMI: number) {
    const pv = (EMI * (1 - Math.pow(1 + monthlyRate, -tenure))) / monthlyRate
    return Math.round(pv / 1000) * 1000 // Round to nearest 1000
  }

  const submitLoanComplete = () => {
    if (loanApplication.applicationCompleteStep < 1.4) {
      dispatch(fetchStartWithForward())
      updateApplication({
        variables: {
          data: { applicationCompleteStep: 1.4 },
          where: { id: loanApplication.id },
        },
      })
    }
    history.push(`/application/${loanApplication.id}?step=2`)
    dispatch(setLoanStep(2))
  }

  const backToLoanEligibility = () => {
    dispatch(setLoanSubStep(3))
    history.replace(`/application/${loanApplication.id}?step=1.3`)
  }

  const additionalProps: any = {
    // prevStep: prevStep,
    // nextStep: nextStep
  }

  const handleCloseOtp = () => {
    setShowOtp(false)
  }

  return (
    <>
      {loanSubStep === 0 && (
        <Step1Sub0 {...additionalProps} sendOTP={sendOTP} setMobileNo={setMobileNo} />
      )}
      {loanSubStep === 1 && <Step1Sub1 createApplication={createApplication} mobileNo={mobileNo} />}
      {loanSubStep === 2 && (
        <>
          {' '}
          <>
            <Step1Sub2
              sendOTP={sendOTP}
              validateOTP={validateOTP}
              mobileNo={mobileNo}
              show={showOtp}
              handleClose={handleCloseOtp}
            />
          </>
          <Step1Sub1 createApplication={createApplication} mobileNo={mobileNo} />
        </>
      )}
      {loanSubStep === 3 && (
        <Step1Sub3
          createLoanEligibility={createLoanElgibility}
          updateLoanElgibility={updateLoanElgibility}
          updateApplication={updateApplication}
        />
      )}
      {loanSubStep === 4 && (
        <Step1Sub4
          {...additionalProps}
          submitLoanComplete={submitLoanComplete}
          backToLoanEligibility={backToLoanEligibility}
        />
      )}

      {showAlert && (
        <Alert variant={alertType} showAlert={showAlert} setShowAlert={setShowAlert}>
          {alertMsg}
        </Alert>
      )}
    </>
  )
}

export { Step1 }
